import React, { useRef, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';

import greenUpArrow from '../../../assets/images/greenUpArrow.png';

const WhatMembersThink = ({ isMobile, width }) => {

  // const satisfiedPadding = width > 1200 ? 0 : 60;

  let satisfiedPadding = 0;
  if(width <1200) satisfiedPadding = 60;
  if(width < 992) satisfiedPadding = -60;

  return (
    <Col>
      <Row>
        <Col>
          {/* @ADVISE - This is an h2 but feels like it should be an h3... */}
          <h2
            id="what-members-think"
            tabIndex="-1"
          >
            What Members Think
          </h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p style={{ marginTop: 30, marginBottom: 30 }}>
            What members think matters most to us. While our Working Groups, Committees and Board of Directors provide feedback throughout the year, we also rely on our member survey.
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={4} style={{
          marginBottom: 200
        }}>
          <DonutChart percent={99.4} color="#C4CDAD">
            <div className="whoWeAreOdometerLabel" style={{ paddingLeft: 20, marginTop: 12, textAlign: 'center', lineHeight: 1.2, fontSize: 24, color: '#004761', fontWeight: 'lighter' }}>
              are <strong style={{ fontWeight: 'bold' }}>satisfied</strong> that <strong style={{ color: '#1B526D', fontWeight: 'bold' }}>CSIO is giving good value</strong> <br /><span style={{ fontWeight: 'lighter', fontSize: 22 }}>(up from 99% in 2020)</span>
            </div>
          </DonutChart>
        </Col>
        <Col xs={12} lg={4} style={{
          marginBottom: 200
        }}>
          <DonutChart percent={99.5} color="#88A078">
            <div className="whoWeAreOdometerLabel" style={{ marginLeft: 20, marginTop: 12, textAlign: 'center', lineHeight: 1.2, fontSize: 24, color: '#004761', fontWeight: 'lighter' }}>
              are <strong style={{ fontWeight: 'bold' }}>satisfied</strong> that <strong style={{ color: '#1B526D', fontWeight: 'bold' }}>CSIO SOLUTIONS, SERVICES AND RESOURCES</strong> HELP THEM BE SUCCESSFUL <br /><span style={{ fontWeight: 'lighter', fontSize: 22 }}>(UP FROM 98% IN 2020)</span>
            </div>
          </DonutChart>
        </Col>
        <Col xs={12} lg={4} style={{
          marginBottom: 200
        }}>
          <DonutChart percent={99.6} color="#3C5C45">
            <div className="whoWeAreOdometerLabel" style={{ marginLeft: 20, marginTop: 12, textAlign: 'center', lineHeight: 1.2, fontSize: 24, color: '#004761', fontWeight: 'lighter' }}>
              are <strong style={{ fontWeight: 'bold' }}>satisfied</strong> with <strong style={{ color: '#1B526D', fontWeight: 'bold' }}>CSIO's work</strong><br /><span style={{ fontWeight: 'lighter', fontSize: 22 }}>(up from 98% in 2020)</span>
            </div>
          </DonutChart>
        </Col>
      </Row>
      <Row style={{ marginTop: satisfiedPadding }}>
        <Col>
          <p>
            “Satisfied” means the responder agrees or strongly agrees with the statement.
          </p>
        </Col>
      </Row>

    </Col>
  )
}

const DonutChart = ({ children, percent, color }) => {
  const [render, setRender] = useState(false);
  const chartRef = useRef(null);

  useEffect(() => {
    const triggerAnimation = () => {
      if (!render && chartRef && chartRef.current && chartRef.current.getBoundingClientRect().top < window.innerHeight) {
        setRender(true);
      };
    }
    window.addEventListener('scroll', triggerAnimation);
    triggerAnimation();
    return () => window.removeEventListener('scroll', triggerAnimation);
  }, [render, chartRef]);

  return (
    <div ref={chartRef} style={{ position: 'static', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
      <div style={{
        position: 'absolute',
        right: 34,
        top: 0,
        height: 40,
        zIndex: 5,
      }}>
        <img
          src={greenUpArrow}
          height="45"
          width="45"
          alt=""
        />
      </div>
      {render && <div style={{
        width: '68%',
        height: '100%',
        textAlign: 'center',
      }}>
        <Chart
          type="doughnut"
          options={{
            animation: {
              duration: 5000
            },
            cutout: '86%',
            radius: '100%',
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                enabled: false
              }
            },
            hover: {
              mode: null
            }
          }}
          data={{
            labels: [
              "",
            ],
            datasets: [{
              label: "",
              data: [percent, 100 - percent],
              backgroundColor: [
                color,
                'transparent'
              ],
              hoverOffset: 0,
            }]
          }} />
      </div>
      }
      <div style={{
        position: 'absolute',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          fontSize: 54,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
        }}>
          {percent}%
        </div>
      </div>
      <div style={{
        position: 'absolute',
        top: '100%'
      }}>
        {children}
      </div>

    </div>
  );
}

export default WhatMembersThink;

/*

      <div style={{
        position: 'absolute',
        width: '68%',
        height: '100%',
        border: '1px solid blue',
        textAlign: 'center'
      }}>
        <div style={{
          position: 'absolute',
          border: '4px solid black',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '64%',
          width: '56%',
          fontSize: 60,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
        }}>
          {percent}%
        </div>
      </div>

*/